<template>
  <div class="OrderTable" v-loading="loading">
    <div class="top_bar">
      <div class="case" style="text-align: right">
        <div class="case-title">
          <img
            class="case-title_icon"
            src="@/assets/images/icon_lb@2x.png"
            alt
          />
          <div class="case-title_max">
            订单列表<span style="color: #ff5757; margin-left: 5px"
              >({{ this.pages.total }})</span
            >
          </div>
        </div>
      </div>
      <el-button
        size="small"
        type="success"
        icon="el-icon-download"
        @click="clickExcel"
        >导出Excel</el-button
      >
    </div>
    <div v-if="this.pages.total > 0">
      <div
        v-for="(item, index) in this.orderTableList"
        :key="index"
        class="order_list"
      >
        <div class="line_top"></div>
        <div class="table_title">
          <div class="left">
            <!-- <div style="margin-right: 30px">
              <div>{{ index + 1 }}</div>
            </div> -->
            <div>
              <span class="first-text">{{ index + 1 }}</span>
              <span style="font-weight: 600;margin-left:50px">订单编号：</span>
              <span :id="'orderNo' + index">{{ item.orderNo }}</span>
              <span class="copy" @click="copy('orderNo' + index)">复制</span>
            </div>
            <div>
              <span style="font-weight: 600">下单时间：</span>
              <span>{{ item.orderTime }}</span>
            </div>
            <div>
              <span style="font-weight: 600">询价门店：</span>
              <span>{{item.storeName!='--'? item.storeName: item.companyName }}</span>
            </div>
          </div>
          <div class="right">
            <div class="rightTrue color1" v-if="item.depreciateState === '00'">待处理</div>
            <div class="rightTrue color2" v-else-if="item.depreciateState === '01'">已确认</div>
            <div class="rightTrue color3" v-else-if="item.depreciateState === '10'">已拒绝</div>
            <!-- <div v-if="item.state === '05' && item.channel == 'Store'" class="rightMid">差异订单</div> -->
            <!-- <div class="rightMid" v-if="item.recycleWay === '01'">以旧换新</div> -->
            <!-- <div class="rightMid" v-if="item.recycleWay === '02'">独立回收</div> -->
            <!-- <div class="rightTrue" v-if="item.businessType === '01' && item.channel == 'Store'">系统报价</div>
          <div class="rightTrue" v-if="item.businessType === '02' && item.channel == 'Store'">工程师报价</div>
          <div class="rightMid" v-if="item.channel == 'Merchant'">回收商自建订单</div> -->
          </div>
        </div>

        <div class="table_list">
          <el-table :data="[item]" border style="width: 100%" id="excelOrder" :header-cell-style="{background:'white'}">
            <!-- *********************************修改*************************************** -->
            <el-table-column
              prop="phoneName"
              label="回收商品"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="typeName"
              label="回收分类"
              align="center"
            ></el-table-column>
            <el-table-column prop="name" label="旧机图片" align="center">
              <template slot-scope="{ row }">
                <div
                  class="images-box"
                  v-if="row.images && row.images.length > 0"
                >
                  <img :src="row.images[0].img" alt="" />
                  <span @click="openImgBox(row)" class="text-down"
                    >共{{ row.images.length }}张</span
                  >
                </div>
                <div v-else>暂无图片</div>
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="storeName"
              label="询价门店"
              align="center"
            ></el-table-column> -->
            <el-table-column prop="phoneName" label="规格" align="center">
              <template slot-scope="{ row }">
                <span>
                  {{ row.phoneName == "--" ? "" : row.phoneName }}
                  {{ row.phoneMemory == "--" ? " " : row.phoneMemory }}
                  {{ row.phoneStorage == "--" ? "" : row.phoneStorage }}
                </span>
                <span
                  v-if="
                    row.phoneName == '--' &&
                    row.phoneMemory == '--' &&
                    row.phoneStorage == '--'
                  "
                  >--</span
                >
              </template>
            </el-table-column>
            <el-table-column prop="staffName" label="询价人员" align="center">
              <template slot-scope="{ row }">
                <span style="display: block">{{ row.staffMobile }}</span>
                <span>{{ row.staffName }}</span>
                <span class="position2"
                  >{{
                    !row.staffType || row.staffType == null
                      ? "--"
                      : row.staffType == "01"
                      ? "(创建人)"
                      : row.staffType == "02"
                      ? "(总监)"
                      : row.staffType == "03"
                      ? "(店长)"
                      : "(店员)"
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="merchantName"
              label="成交回收商"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="quotePrice"
              label="确认报价金额"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="depreciatePriceStore"
              label="收货降价金额"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="merchantPrice"
              label="商家实收价"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="finalPrice"
              label="用户成交价"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="depreciateInitiatorTime"
              label="差价发起时间"
              align="center"
            ></el-table-column>
            <el-table-column label="差价原因"  align="center">
              <template slot-scope="{ row }">
                <el-tooltip :content="row.depreciateRemark" placement="top">
                  <p style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;">{{row.depreciateRemark}}</p>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="订单详情"
              align="center"
            >
              <template slot-scope="scope">   
                <el-button @click="handleClickDetails(scope.row)" type="primary" round size="small">查看</el-button>
              </template>
            </el-table-column>
            <!-- *********************************修改*************************************** -->
            <el-table-column fixed="right" label="操作" width="200" align="center">
              <template slot-scope="scope">
                <div v-if="isCustomUser">
                  <el-button v-if="scope.row.depreciateState=='00'" @click="handleClick(scope.row,'00')" type="primary" round size="small">确认差价</el-button>
                  <el-button v-if="scope.row.depreciateState=='00'" @click="handleClick(scope.row,'01')" type="warning" round size="small">拒绝差价</el-button>
                  <el-button v-if="scope.row.depreciateState=='01'"  disabled type="primary" round size="small">已确认</el-button>
                  <el-button v-if="scope.row.depreciateState=='10'"  disabled type="info" round size="small">已拒绝</el-button>
                  <el-button v-if="scope.row.depreciateState=='10'" @click="handleClick(scope.row,'04')" type="success" round size="small">拒绝原因</el-button>
                </div>
                <el-button v-else type="text" disabled>不可操作</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="orderPagina">
        <el-pagination
          background
          :current-page="pages.currentPage"
          :page-size="10"
          layout="total, prev, pager, next,jumper"
          :total="this.pages.total"
          class="el-pagination-c"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <div v-else style="width:100%;text-align:center;padding:80px 0;font-size: 24px;color: #666666;background:white;font-weight: bold;">
      暂无订单~
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :width="`${800}px`"
      title="查看旧机照片"
      :visible="imgShow"
      @close="imgClose"
      top="5%"
    >
      <div class="img-box">
        <div class="img-tips-box">
          <div
            @click="chooseImages(0)"
            class="img-tips"
            :class="imgShowOnly ? 'img-tips-choose' : 'img-tips-default'"
          >
            旧机照片
          </div>
          <div
            v-if="this.DialogImgList[1].length > 0"
            @click="chooseImages(1)"
            class="img-tips"
            :class="imgShowOnly ? 'img-tips-default' : 'img-tips-choose'"
          >
            补拍照片
          </div>
        </div>
        <div class="img-show">
          <div class="imgs-num" v-if="DialogImgList[imgIndex].length > 0">
            {{ imgShowIndex + 1 }}/{{ DialogImgList[imgIndex].length }}
          </div>
          <div class="block">
            <viewer :images="DialogImgList[imgIndex]">
              <el-carousel trigger="click" height="80vh" @change="getindex">
                <el-carousel-item
                  v-for="item in this.DialogImgList[this.imgIndex]"
                  :key="item.imgNo"
                >
                  <div class="sec_img">
                    <img :src="item.img" alt="" />
                  </div>
                </el-carousel-item>
              </el-carousel>
            </viewer>
          </div>
          <!-- <LookImg :images="imgList"/> -->
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :width="`${1000}px`"
      title="查看参与报价回收商"
      :visible="storeShow"
      @close="storeClose"
      top="15%"
    >
      <div class="img-box">
        <div class="table_list">
          <el-table
            :data="storeList"
            border
            style="width: 100%"
            id="excelOrder"
          >
            <el-table-column
              prop="index"
              type="index"
              label="序号"
            ></el-table-column>
            <el-table-column
              prop="recycleMerchantName"
              label="报价商家"
              align="center"
            >
              <template scope="{ row }">
                <span
                  class="position isdeal"
                  v-if="row.recycleMerchantName == merchantName"
                  >成交</span
                >
                <span>{{ row.recycleMerchantName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="quotePrice"
              width="100"
              label="报价金额"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="quoteTime"
              width="180"
              label="报价时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="staffName"
              label="报价人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="staffMobile"
              label="账号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="staffType"
              label="角色"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="quoteNum"
              width="100"
              label="报价次数"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="导出数据显示"
      :visible="excelVisible"
      :close-on-click-modal="false"
      :width="`${500}px`"
      @close="excelVisible = false"
      top="15%"
    >
      <div style="display: flex; margin: 10px 20px">
        <div
          style="
            width: 80px;
            line-height: 30px;
            height: 30px;
            color: #666666;
            font-size: 14px;
          "
        >
          选时间段
        </div>
        <el-date-picker
          size="small"
          v-model="valueTime"
          type="daterange"
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          value-format="timestamp"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div style="margin: 40px 0; float: right">
        <el-button @click="excelVisible = false" size="mini">取消</el-button>
        <el-button @click="submitExcel" :loading="exportLoading" type="primary" size="mini"
          >确认导出</el-button
        >
      </div>
    </el-dialog>
    <el-dialog 
      :visible="priVisible"
      :close-on-click-modal="false"
      :width="`${this.widthDia}px`"
      @close="priVisible = false"
      :title="deStateTitle"
      top="15%"
    >
      <div v-if="this.deStateDia=='00'" style="text-align:center;color: #333333;font-size: 16px;margin:20px 0;">
        确定要确认该差价订单吗？
      </div>
      <div v-else-if="this.deStateDia=='01'" style="display:flex;justify-content: center;">
        <span style="width:80px">差价原因</span>
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请填写拒绝原因（50字以内）"
            maxlength="50"
            v-model="Notextarea">
          </el-input>
      </div>
      <div v-else-if="this.deStateDia=='04'" style="display:flex;justify-content: center;">
        <span style="width:80px">差价原因</span>
          <el-input
            type="textarea"
            :rows="6"
            maxlength="50"
            placeholder="请填写拒绝原因（50字以内）"
            disabled
            v-model="Notextarea">
          </el-input>
      </div>
      <div style="margin: 20px 0; float: right">
        <el-button @click="priVisible = false" size="small">取消</el-button>
        <el-button @click="submitDiaClick" type="primary" size="small">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
import { MessageBox } from "element-ui";
export default {
  name: "OrderTable",
  // components:{
  //   'LookImg': () => import('@/components/lookImg')
  // },
  data() {
    return {
      isCustomUser: "",
      priVisible:false,
      orderNoDia:'',
      deStateTitle:'',
      deStateDia:'',
      Notextarea:'',
      widthDia:'',
      // 导出弹窗
      valueTime: "",
      excelVisible: false,
      /*********** 新增 **********/
      imgShow: false,
      imgShowOnly: true,
      DialogImgList: [[], []],
      imgShowIndex: 0,
      imgIndex: 0,
      storeShow: false,
      storeList: [],
      /*********** 新增 **********/
      pages: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
      itemArr: [],
      itemTable: [],
      orderTableList: [],
      loading: false,
      exportLoading: false
    };
  },
  created() {
    this.isCustomUser = JSON.parse(localStorage.getItem('user')).xcxStaffId
    let startTime = moment()
      .day(moment().day() - 14)
      .format("YYYY-MM-DD 00:00:00"); // 当前时间往前推一周的时间
    let endTime = moment().format("YYYY-MM-DD 23:59:59");
    this.ClearSeachParams();
    const baseRequest = {
      endTime: moment(endTime).format("x"),
      startTime: moment(startTime).format("x"),
      companyId: Number(this.$route.query.companyId) || "",
    };
    this.$store.commit("tagsView/SEACH_PARAMS", baseRequest);
    // this.handleCurrentChange();
  },
  computed: {
    SeachParams() {
      console.log(this.$store.state.tagsView.SeachParams);
      return this.$store.state.tagsView.SeachParams;
    },
  },
  watch: {
    SeachParams(newval) {
      console.log(newval);
      this.handleCurrentChange();
    },
  },
  methods: {
    ClearSeachParams() {
      this.$store.dispatch("tagsView/ClearSeachParams", "");
    },
    submitExcel() {
      if (this.valueTime) {
        const params = {
          startTime: this.valueTime[0],
          endTime: this.valueTime[1],
        };
        this.exportLoading = true
        _api
          .excelDepreciate(params)
          .then((res) => {
            console.log(res);
            const content = res;
            const blob = new Blob([content]);
            let reader = new FileReader(); // 创建读取文件对象
            reader.addEventListener("loadend", () => {
              try {
                let data = JSON.parse(reader.result);
                if (data.code === 0) {
                  MessageBox.alert(data.msg || "服务异常", "错误提示", {
                    type: "error",
                  });
                }
              } catch (err) {
                let start = moment(Number(params.startTime)).format("YYYY.MM.DD");
                let end = moment(Number(params.endTime)).format("YYYY.MM.DD");
                const fileName = `【差价订单列表】${start}-${end}.xlsx`;
                if ("download" in document.createElement("a")) {
                  // 非IE下载
                  const elink = document.createElement("a");
                  elink.download = fileName;
                  elink.style.display = "none";
                  elink.href = URL.createObjectURL(blob);
                  document.body.appendChild(elink);
                  elink.click();
                  URL.revokeObjectURL(elink.href); // 释放URL 对象
                  document.body.removeChild(elink);
                } else {
                  // IE10+下载
                  navigator.msSaveBlob(blob, fileName);
                }
              }
            });
            reader.readAsText(blob, "utf-8");
            this.exportLoading = false
          })
          .catch((err) => {
            this.exportLoading = false
            console.log(err);
          });
      } else {
        this.$message({
          message: "请选择导出时间查询",
          type: "error",
        });
      }
    },
    clickExcel() {
      this.excelVisible = true;
    },
    handleClick(row,val) {
      this.priVisible = true
      this.orderNoDia = row.orderNo
      this.deStateDia = val
      console.log(row)
      if(this.deStateDia==='00'){
        this.deStateTitle = '确认差价'
        this.widthDia = 380
      }else if(this.deStateDia==='01'){
        this.deStateTitle = '拒绝差价'
        this.widthDia = 500
      }else if(this.deStateDia==='04'){
        this.deStateTitle = '拒绝差价'
        this.widthDia = 500
        this.Notextarea = row.depreciateRefuseCause 
      }
    },
    handleClickDetails(row) {
      let routeData = this.$router.resolve({ path: '/RecallOrder/Details', query: { type: "edit", id: row.orderNo }, });
      window.open(routeData.href, '_blank');
    },
    submitDiaClick(){
      if(this.deStateDia=='00'){
        console.log('123')
        _api.confirmDepreciate({orderNo:[this.orderNoDia]}).then(res=>{
          console.log(res)
          if(res.code==1){
            this.$message.success('操作成功')
            this.handleCurrentChange()
          }
        })
      }else if(this.deStateDia==='01'){
        console.log('123')
        _api.rejectDepreciate({orderNo:this.orderNoDia,depreciateRefuseCause:this.Notextarea}).then(res=>{
          console.log(res)
          if(res.code==1){
            this.$message.success('操作成功')
            this.handleCurrentChange()
          }
        })
      }
      this.priVisible = false
    },
    handleCurrentChange(val) {
      this.loading = true;
      console.log(val + "val");
      if (val) {
        this.pages.currentPage = val;
      } else {
        this.pages.currentPage = 1;
      }
      console.log(this.SeachParams.endTime);
      const vo = {
        businessType: this.SeachParams.businessType,
        depreciateState: this.SeachParams.depreciateState,
        recycleWay: this.SeachParams.recycleWay,
        phoneName: this.SeachParams.phoneName,
        state: this.SeachParams.state,
        storeId: this.SeachParams.storeId,
        companyId: this.SeachParams.companyId,
        endTime: this.SeachParams.endTime,
        merchantId: this.SeachParams.merchantId,
        orderNo: this.SeachParams.orderNo,
        pageNum: this.pages.currentPage,
        pageSize: this.pages.pageSize,
        startTime: this.SeachParams.startTime,
        typeId: this.SeachParams.typeId,
      };
      _api.listByDepreciate(vo).then((res) => {
        console.log(res);
        if (res.code === 1) {
          this.pages.total = res.data.total;
          this.itemTable = res.data.records;
          this.orderTableList = [];
          for (let i = 0; i < this.itemTable.length; i++) {
            this.itemArr = this.itemTable[i];
            this.orderTableList.push(this.handleData(this.itemArr)); // 数据重新组装重置为--
            if (i > 10) {
              return;
            }
          }
          this.loading = false;
          console.log(this.orderTableList);
        }
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      }).catch(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    /********* 5-18新增 ************/
    copy(e) {
      const spanText = document.getElementById(e).innerText;
      const oInput = document.createElement("input");
      oInput.value = spanText;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      document.body.removeChild(oInput);
      this.$message.success("复制成功");
    },
    openImgBox(row) {
      console.log(row);
      this.imgShow = true;
      // this.imgList = e
      this.DialogImgList = [
        [...(row.images == "--" || !row.images ? [] : row.images)],
        [...(row.reImages == "--" || !row.reImages ? [] : row.reImages)],
      ];
      console.log(this.DialogImgList);
    },
    chooseImages(e) {
      if (e == 0) {
        this.imgIndex = 0;
        this.imgShowOnly = true;
      }
      if (e == 1) {
        this.imgIndex = 1;
        this.imgShowOnly = false;
      }
    },
    getindex(e) {
      console.log(e);
      this.imgShowIndex = e;
    },
    imgClose() {
      console.log(1);
      this.imgShow = false;
      this.imgList = [];
    },
    // 报价商家弹窗
    openStoreList(e) {
      console.log(e);
      this.merchantName = e.merchantName;
      // _api.orderStoreList({ orderNo:e.orderNo }).then(res => {
      //   if (res.code == 1) {
      //     for (const item of res.data) {
      //       this.handleData(item)
      //     }
      //     this.storeList = res.data
      //   }
      // })
      this.storeShow = true;
    },
    storeClose() {
      this.storeShow = false;
      this.storeList = [];
    },
    // 所有不为真的第一层数据重置为--
    handleData(param) {
      for (const key in param) {
        if (Object.prototype.toString.call(param[key]) === "[object Object]") {
          this.handleData(param[key]);
        } else if (!param[key] || param[key] == undefined || param[key] == "") {
          param[key] = "--";
        }
      }
      return param;
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.OrderTable {
  .top_bar {
    background: white;
    display: flex;
    justify-content: space-between;
    .case {
      display: flex;
      align-items: center;
      justify-content: space-between;
      align-items: center;
      .case-title {
        display: flex;
        .case-title_icon {
          width: 20px;
          height: 20px;
        }
        .case-title_max {
          font-weight: bold;
          color: #333333;
          font-size: 18px;
          // width: 80px;
          height: 17px;
          line-height: 17px;
          margin-left: 5px;
          font-family: FZLanTingHei-B-GBK;
        }
      }
    }
  }
  .orderPagina {
    float: right;
    margin: 50px;
  }
  /deep/ .el-table th{
    padding: 3px 0!important;
  }
  .order_list {
    .line_top {
      background-color: white;
      width: 100%;
      height: 10px;
    }
    .table_title {
      display: flex;
      height: 40px;
      align-items: center;
      justify-content: space-between;
      background: #E4ECFD;
      border-radius: 6px 6px 0px 0px;
      .left {
        width: 75%;
        display: flex;
        position: relative;
        justify-content: space-between;
        div {
          margin-right: 100px;
          .first-text {
            display: inline-block;
            width: 32px;
            height: 22px;
            background: #ffaf29;
            border-radius: 3px 11px 11px 3px;
            color: white;
            line-height: 22px;
            position: absolute;
            text-align: center;
            top: 0;
            left: -5px;
            margin-right: 50px;
            margin-top: -2px;
          }
          > span {
            font-size: 14px;
            font-family: FZLanTingHei-DB-GBK;
            font-weight: 400;
            color: #0981ff;
          }
          > input {
            border: none;
            background: none;
            color: #0981ff;
            padding: 0;
            width: 140px !important;
            font-size: 14px;
          }
          > .copy {
            width: 36px;
            height: 16px;
            display: inline-block;
            line-height: 16px;
            text-align: center;
            background: #0981ff;
            color: #fff;
            margin-left: 8px;
            border-radius: 4px;
            font-size: 12px;
            cursor: pointer;
          }
        }
      }
      .right {
        display: flex;
        color: #fff;
        .rightTrue {
          font-size: 14px;
          text-align: center;
          width: 70px;
          height: 22px;
          line-height: 22px;
          border-radius: 11px 0px 0px 11px;
        }
        .color1{
          background: #F75846;
        }
        .color2{
          background: #0981FF;
        }
        .color3{
          background: #B3B3B3;
        }
      }
    }
  }
}
// 表格样式+
.position {
  width: max-content;
  display: block;
  padding: 0px 4px;
  font-size: 14px;
  background-color: rgba(102, 204, 153, 1);
  margin: 0 auto;
  border-radius: 5px;
  color: #fff;
  text-align: center;
}
.position2 {
  width: max-content;
  display: block;
  padding: 0px 4px;
  font-size: 14px;
  margin: 0 auto;
  border-radius: 5px;
  text-align: center;
}
.images-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.images-box > img {
  width: 70px;
  height: 70px;
  margin-bottom: 10px;
}
.images-box > span {
  color: #0981ff;
  cursor: pointer;
}
.color-green {
  color: rgba(102, 204, 153, 1);
}
.color-red {
  color: #ff687b;
}
.text-down {
  text-decoration: underline;
  color: #0981ff;
}
// 弹窗
.img-box {
  margin-bottom: 20px;
  // 图片
  .imgs-num {
    text-align: center;
    margin: 5px 0;
    font-weight: bold;
  }
  .img-tips-box {
    display: flex;
    height: 30px;
    width: max-content;
    border: 1px solid #0981ff;
    .img-tips {
      width: 80px;
      text-align: center;
      line-height: 30px;
      box-sizing: border-box;
      cursor: pointer;
    }
    .img-tips-default {
      background: #fff;
      color: #0981ff;
    }
    .img-tips-choose {
      background: #0981ff;
      color: #fff;
    }
  }
  // 列表
}
.isdeal {
  background: #ff687b;
  margin-right: 5px;
  display: inline-block;
}
.sec_img {
  width: 20vw;
  height: 80vh;
  margin: auto;
  img {
    width: 20vw;
    height: 80vh;
    object-fit: contain;
  }
}
</style>
